import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { useStaticQuery, graphql } from "gatsby";
import { useTranslation } from "react-i18next";
import cx from "classnames";
import MenuArrowIcon from "../../../../assets/svgs/menu-arrow-next.svg";

import Link from "../../../Link";
import SubMenuItem from "../SubMenuItem";
import LatestPostCard from "../LatestPostCard";

const SubMenus = ({ setMenuPage, mainMenu, contents }) => {
  const { t } = useTranslation();

  const data = useStaticQuery(graphql`
    {
      ...EarnMenuIcons
      ...RewardsMenuIcons
      ...TradeMenuIcons
      ...LearnMenuIcons
    }
  `);

  return (
    <div className="mobile-menu d-flex flex-column justify-content-between h-100">
      <div className="container">
        <div className="d-flex flex-column mt-3 mb-5 w-100">
          <button
            className="mobile-menu__back-btn d-flex btn btn-back px-0 pt-0 pb-3"
            onClick={() => setMenuPage(null)}
          >
            <StaticImage
              imgClassName="back"
              src={"../../../../assets/images/icons/arrow-icon.png"}
              alt="back"
              width={16}
              height={16}
              placeholder="blurred"
            />
          </button>

          <div className="d-flex mt-2 mb-4">
            <span className="title text-capitalize">
              {mainMenu} (
              {contents?.subMenus.length + (contents?.headerTo ? 1 : 0)})
            </span>
          </div>

          {contents?.header && (
            <Link
              className={cx("px-0 mt-1 mb-4 col-md-6", {
                disabled: contents.header.disabled,
              })}
              to={contents.header.to}
            >
              <div className="d-flex align-items-center mb-2">
                <h5 className="mb-0">{t(`menu.${mainMenu}.content.title`)}</h5>
                {contents.header.isInProgress ? (
                  <div className="badge ml-2 py-1 px-2">COMING SOON</div>
                ) : (
                  <MenuArrowIcon className="ml-2" />
                )}
              </div>
              <span>{t(`menu.${mainMenu}.content.description`)}</span>
            </Link>
          )}

          <div className="row">
            {contents?.subMenus.map((subMenu, i) => (
              <div
                key={`${subMenu.title}-${i}`}
                className="col-12 col-md-6 mb-md-3"
              >
                <SubMenuItem
                  title={t(`menu.${mainMenu}.${subMenu.title}.title`)}
                  description={
                    subMenu.onlyTitle
                      ? null
                      : t(`menu.${mainMenu}.${subMenu.title}.description`)
                  }
                  imageSrc={data[`${subMenu.title}Icon`].publicURL}
                  linkTo={subMenu.to}
                  isInProgress={subMenu.isInProgress}
                  disabled={subMenu.disabled}
                />
              </div>
            ))}
          </div>

          {contents?.latestPosts && (
            <>
              <div className="border-top mt-3 mb-5" />
              <div className="row px-2">
                <LatestPostCard post={contents.latestPosts[0]} />
                <LatestPostCard
                  className="d-none d-md-block ml-4"
                  post={contents.latestPosts[1]}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubMenus;
